<template>
    <v-layout
        class="border mb-2 mt-4"
        :class="{'borderFluCovid':isCovidOrFluService}"
    >
        <v-flex
            class="theme--light pa-2"
            :class="setShowCovidFluChip"
        >
            {{ (required ? '* ' : '') }}
            <span class="body-1" v-html="getTitle" /><br />
            <p v-if="getDescription" class="description my-2" v-html="getDescription" />
            <v-radio-group
                class="body-2 ml-4 mt-0"
                :value="value"
                :outline="outline"
                type="radio"
                :rules="[
                    v => !required || v === 0 || v === 1 || $t('base.errors.requiredField')
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @change="emitValue"
            >
                <v-radio :label="$t('base.yes')" :value="1" />
                <v-radio :label="$t('base.no')" :value="0" />
            </v-radio-group>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { includes } from 'lodash';
import { CoAdministrationServiceTemplateIds } from '@/enums';

export default {
    name: 'is-other-service-wanted',
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: Number, required: false, default: null },
        withIcon: { type: Boolean, required: false, default: false },
        serviceId: { type: Number, required: false, default: null },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            locale: 'locale',
            getInstantiateServiceById: 'services/getInstantiateServiceById',
        }),
        getTitle() {
            if (this.isCovidOrFluService && includes(['covid', 'flu'], this.isCovidOrFluService)) {
                return this.$i18n.t(`coAdministrationFluCovid.metadata.${this.isCovidOrFluService}.title`);
            }
            return this.metadata[`description${this.upperLocale}`];
        },
        getDescription() {
            if (this.isCovidOrFluService && includes(['covid', 'flu'], this.isCovidOrFluService)) {
                return this.$i18n.t(`coAdministrationFluCovid.metadata.${this.isCovidOrFluService}.description`);
            }
            return false;
        },
        isCovidOrFluService() {
            const service = this.getInstantiateServiceById(this.serviceId);
            if (service.serviceTemplate &&
                includes([CoAdministrationServiceTemplateIds.FLU, CoAdministrationServiceTemplateIds.COVID], service.serviceTemplate.id)
            ) {
                return service.serviceTemplate.id === CoAdministrationServiceTemplateIds.COVID ? 'covid' : 'flu';
            }
            return false;
        },
        setShowCovidFluChip() {
            return this.isCovidOrFluService ? 'show-covid-flu-chip-' + this.locale : '';
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.border::v-deep {
    border: 2px solid var(--v-primary-base)!important;
    border-radius: 4px!important;
}

.borderFluCovid::v-deep {
    border: 4px solid #FCC987!important;
    border-radius: 4px;
}

.show-covid-flu-chip-fr {
    background-image:  url('https://static.trimoz.com/clicsante/images/pastille-grippe-covid-fr.png');
    background-position: 100% 90%;
    background-repeat: no-repeat;
    background-size: 100px 100px;
}

.show-covid-flu-chip-en {
    background-image:  url('https://static.trimoz.com/clicsante/images/pastille-grippe-covid-en.png');
    background-position: 100% 90%;
    background-repeat: no-repeat;
    background-size: 100px 100px;
}

.description {
    color: #ef6c00;
}

</style>
